<div class="header">
  <div class="title_container">
    <app-page-close-button (closePage)="goBack()"></app-page-close-button>
    <div class="title">Register Shipping BIll</div>
  </div>
  <div class="buttons">
    <button class="btn secondary_button" (click)="goBack()">Cancel</button>
    <button class="btn primary_button" (click)="saveShippingBill()"
            *ngIf="!readOnlyMode">{{ editOnlyMode ? 'Update' : 'Save' }}
    </button>
  </div>
</div>
<div class="container">
  <div class="card">
    <div class="card_title">Customer Information</div>
    <div class="divider"></div>
    <app-dynamic-form
      [formConfig]="containerInfoFormConfig"
      [formGroup]="containerInfoFormGroup"
    ></app-dynamic-form>
  </div>

  <div class="card">
    <div class="card_title">Vessel Information</div>
    <div class="divider"></div>
    <app-dynamic-form
      [formConfig]="vesselInfoFormConfig"
      [formGroup]="vesselInfoFormGroup"
    ></app-dynamic-form>
  </div>

  <div class="card" style="margin-bottom: 100px">
    <div class="card_title">Cargo Information</div>
    <div class="divider"></div>
    <app-dynamic-form
      [formConfig]="cargoInfoFormConfig"
      [formGroup]="cargoInfoFormGroup"
    ></app-dynamic-form>
    <div class="divider"></div>
    <div class="card_title">Marks & Number</div>
    <div class="marks_and_number_table">
      <app-editable-table
        [tableHeaders]="marksAndNumbersEditableTableConfig"
        [(tableData)]="marksAndNumberData"
        (dataUpdated)="handleTableDataChange($event)"
        [showInputFieldsOnTh]="false"
        [deletionAllowed]="true"
        (dataDeleted)="handleDataDeletion($event)"
      ></app-editable-table>
      <button class="btn ghost_button" (click)="addNewRange()">
        <app-svg-icon path="assets/icons/plus_icon.svg" style="width: 24px;height: 24px;display: flex"></app-svg-icon>Add New</button>
    </div>
  </div>
</div>


